import { useState } from "react";

import { switchCompany, switchBack } from "../api/executiveCompanyApi";

interface UseSwitchCompanyResult {
	switchTo: (companyId: number) => Promise<void>;
	switchBack: () => Promise<void>;
	isLoading: boolean;
}

export const useSwitchCompany = (): UseSwitchCompanyResult => {
	const [isLoading, setIsLoading] = useState(false);

	const switchTo = async (companyId: number): Promise<void> => {
		setIsLoading(true);
		try {
			await switchCompany(companyId);
			window.location.assign("/");
		} finally {
			setIsLoading(false);
		}
	};

	const handleSwitchBack = async (): Promise<void> => {
		setIsLoading(true);
		try {
			await switchBack();
			window.location.assign("/");
		} finally {
			setIsLoading(false);
		}
	};

	return {
		switchTo,
		switchBack: handleSwitchBack,
		isLoading,
	};
};
